var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid === false),expression:"valid === false"}],staticClass:"error"},[_vm._v("close")])],1),_vm._v(" "),_c('slide-y-down-transition',[_c('md-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid === true),expression:"valid === true"}],staticClass:"success"},[_vm._v("done")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Validation/ErrorIndicator.vue